(function () {
  'use strict';

  angular
    .module('itecAdministracio.productes.main.submain.edit')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('productes.main.submain.edit', {
        url: '/edit',
         params: {
          isNew : false
        },
      views: {
          'headerSubmenu@': {
            templateUrl: 'shared/header-submenu/headerSubmenu.tpl.html',
            controller: 'HeaderSubmenuCtrl',
            controllerAs: 'vm',
            resolve: {
              optionsHeaderSubmenuData: function(permisosProductesHeaderSubmenuLinksValue){
                return permisosProductesHeaderSubmenuLinksValue;
              }
            }
          },
          'content@productes.main.submain': {
            templateUrl: 'productes/main/edit/edit.tpl.html',
            controller: 'ProductesMainEditCtrl',
            controllerAs: 'ctrl'  ,
            resolve: {
              llistaaplicacions: function(AplicacioFactory) {
                return AplicacioFactory.getAll().catch(function(){});
              }
            }
          }
        }
      });
  }
}());
